import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { TransactionTypeString, transactionTypeCharMap } from '@tassat/common-definitions';
import { TransactionHistoryRecord } from '@tassat/fred-extended-definitions';
import React from 'react';

interface ClientCounterpartyFirmCellRendererProps {
    data: TransactionHistoryRecord;
}

const muiStyles = makeStyles({
    root: { height: '100%' },
    name: { lineHeight: '20px' }
});

const ClientCounterpartyFirmCellRenderer = (props: ClientCounterpartyFirmCellRendererProps) => {
    const { data } = props;

    const classes = muiStyles(props);
    const tranType: string = (transactionTypeCharMap(data.type as any) as string);
    const counterpartyIsSender = React.useMemo<boolean>(() => {
        // will be true for
        // tranType === TransactionTypeString.receive
        let counterpartyIsSender = true;

        if (tranType === TransactionTypeString.send) {
            counterpartyIsSender = false;
        }

        return counterpartyIsSender;
    }, [tranType]);

    const displayValue = React.useMemo<string>(() => {
        if (counterpartyIsSender) {
            return data.SenderFirm;
        }

        if (!counterpartyIsSender) {
            return data.RecipientFirm;
        }

        return '';
    }, [
        counterpartyIsSender,
        data.SenderFirm,
        data.RecipientFirm
    ]);

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
            justifyContent='center'
            spacing={0}
        >
            <span className={classes.name}>{displayValue}</span>
        </Grid>
    );
};

export default ClientCounterpartyFirmCellRenderer;